var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
/**
 * 前端资源加载情况监控，成功、失败都要监控。
 * html的标签、动态添加的标签，都通过 MutationObserver 实现
 */
import * as util from './utils';
import { LogType } from '../../interface';
import { immediateSend, reportAll } from '../../index';
import { RESOUCE_TYPE, MONITOR_TAGS } from './constant';
// 加载情况
export var LOAD_STATUS = {
    SUCCESS: true,
    FAILED: false
};
// 是否支持performance
var IS_SUPPORT_PERFORMANCE = window.performance &&
    typeof window.performance.getEntriesByName === 'function';
var IS_SUPPORT_MUTATION_OBSERVER = typeof MutationObserver !== 'undefined' && (util.isNative(MutationObserver) ||
    MutationObserver.toString() === '[object MutationObserverConstructor]');
var ALL_ASSTES = []; // 存放页面所有上报过的资源
var isWindowLoaded = false; // 检测是否初次加载页面，是则累计上报
var cachedDataBeforeLoad = []; // 缓存页面 onload 前的监控数据
// 获取 外部资源/接口 上报数据
function getElemReportData(elem, isLoadSuccess, time) {
    if (time === void 0) { time = 0; }
    if (!elem)
        return null;
    var url = util.getUrl(elem); // 资源url
    if (!url || url.search('chrome-extension') > -1)
        return null;
    var entries = {};
    var costTime = time;
    if (IS_SUPPORT_PERFORMANCE) {
        var entiresArr = window.performance.getEntriesByName(url);
        if (entiresArr.length) {
            entries = util.setPropToInt(entiresArr[entiresArr.length - 1]);
            costTime = entries.duration;
        }
    }
    return {
        url: url,
        success: isLoadSuccess,
        cost_time: costTime,
        resource_type: util.getResourceType(elem),
        page_url: window.location.href,
        success_performance: util.encodeData(entries || {}) // performance整个对象
    };
}
// 外部资源 上报/缓存
function report(elem, isLoadSuccess, time, errorType, errorMsg, statusCode, extendData) {
    if (time === void 0) { time = 0; }
    if (errorType === void 0) { errorType = 0; }
    if (errorMsg === void 0) { errorMsg = ''; }
    if (statusCode === void 0) { statusCode = ''; }
    if (extendData === void 0) { extendData = {}; }
    try {
        if (!IS_SUPPORT_PERFORMANCE)
            return;
        var data = getElemReportData(elem, isLoadSuccess, time);
        if (data) {
            // 图片，过滤base64
            if (data.resource_type === RESOUCE_TYPE.IMG &&
                data.url.includes('data:image/png;base64'))
                return;
            // 非接口，且已加载过
            if (data.resource_type !== RESOUCE_TYPE.XHR &&
                ALL_ASSTES.includes(data.url))
                return;
            ALL_ASSTES.push(data.url);
            // 接口，增加失败信息
            if (data.resource_type === RESOUCE_TYPE.XHR) {
                data.error_type = errorType || 0; // 失败类型: 1 超时类，2 status !== 200类，3 其他错误
                data.error_msg = errorMsg || ''; // 失败具体信息
                data.status_code = statusCode || ''; // 失败状态码
                data = __assign(__assign({}, data), (extendData || {})); // 拼上 业务要上报的数据
            }
            // 上报数据
            if (!isWindowLoaded) {
                cachedDataBeforeLoad.push(data);
            }
        }
    }
    catch (err) {
        console.error(err);
    }
}
// 监听onload onerror
function listenLoadEvent(elem) {
    elem.addEventListener('load', function () { return report(elem, LOAD_STATUS.SUCCESS); });
    elem.addEventListener('error', function () { return report(elem, LOAD_STATUS.FAILED); });
}
// 监听动态插入的标签
function observeTagInsert() {
    if (!IS_SUPPORT_MUTATION_OBSERVER)
        return;
    var config = { attributes: false, childList: true, subtree: false };
    var observer = new MutationObserver(function (mutationsList) {
        Array.from(mutationsList).forEach(function (mutation) {
            if (mutation.type === 'childList') {
                Array.from(mutation.addedNodes).forEach(function (elem) {
                    var tagName = elem.tagName;
                    if (tagName && MONITOR_TAGS.includes(tagName.toLowerCase())) {
                        listenLoadEvent(elem); // 监听 请求成功/失败
                    }
                });
            }
        });
    });
    observer.observe(document.head, config);
    // body非动态加载的资源
    document.onreadystatechange = function () {
        if (document.readyState === 'interactive') {
            observer.observe(document.body, config);
        }
    };
}
// onload前 js加载 用时最长的资源的时长
function getJsCostTimeBeforeLoad() {
    var costTimeArr = cachedDataBeforeLoad.map(function (item) {
        return item.resource_type === RESOUCE_TYPE.JS ? item.cost_time : 0;
    });
    return Math.max.apply(Math, __spreadArrays(costTimeArr, [0]));
}
// 页面性能上报，参数：采样率
function sendPerformanceRequest() {
    if (!IS_SUPPORT_PERFORMANCE)
        return {};
    // FP/FCP
    var paintArr = Array.from(performance.getEntriesByType('paint'));
    var _a = paintArr.length ? paintArr : [{}, {}], fp = _a[0], fcp = _a[1];
    var paintTime = {
        FP: fp ? parseInt(fp.duration + fp.startTime, 10) : null,
        FCP: fcp ? parseInt(fcp.duration + fcp.startTime, 10) : null
    };
    // performance整串数据，按照navigation格式上报
    // timing 比 naviagtion 多以下属性：domLoading、navigationStart
    // timing 比 naviagtion 少以下属性：
    // decodedBodySize、duration、encodedBodySize、entryType、initiatorType、name、nextHopProtocol、
    // redirectCount、secureConnectionStart、serverTiming、startTime、transferSize、type、workerStart
    var performanceData = {};
    var navaigation = performance.getEntriesByType('navigation');
    if (navaigation && navaigation.length) {
        performanceData = util.setPropToInt(navaigation[0]);
    }
    else {
        var timing = window.performance.timing;
        for (var prop in timing) {
            performanceData[prop] = Math.max(+timing[prop] - timing.navigationStart, 0);
        }
    }
    // 之前上报的数据
    var dnsTime = performanceData.connectEnd - performanceData.domainLookupStart;
    var htmlTime = performanceData.responseEnd - performanceData.requestStart;
    var loadTime = performanceData.loadEventEnd ||
        performanceData.loadEventStart ||
        performanceData.domComplete ||
        performanceData.domInteractive;
    var jsCostTime = getJsCostTimeBeforeLoad();
    return {
        dns_cost_time: dnsTime,
        html_cost_time: htmlTime,
        js_cost_time: jsCostTime,
        load_cost_time: loadTime,
        paint_time: paintTime,
        performance: performanceData // performance整个对象
    };
}
// 遍历body子元素，调用上报函数
function bodyAssetsPushToCached() {
    if (document.body) {
        Array.from(document.body.childNodes).forEach(function (elem) {
            var tagName = elem.tagName;
            if (tagName && MONITOR_TAGS.includes(tagName.toLowerCase())) {
                var url = util.getUrl(elem);
                if (IS_SUPPORT_PERFORMANCE) {
                    report(elem, !!window.performance.getEntriesByName(url)[0]);
                }
            }
        });
    }
}
// 根据页面 dom 数检测白屏
function detectWhiteScreen() {
    // 页面最少要存在的 dom 数
    var LEAST_DOM_NUM = 10;
    function countNodes(node) {
        var count = 1;
        // 超过设定的 dom 数认为不是白屏，结束递归
        if (count >= LEAST_DOM_NUM)
            return 0;
        if (node.hasChildNodes()) {
            var cnodes = node.childNodes;
            for (var i = 0; i < cnodes.length; i++) {
                if (count >= LEAST_DOM_NUM)
                    break;
                if (cnodes.item(i).nodeType === 1) {
                    count = count + countNodes(cnodes.item(i));
                }
            }
        }
        return count;
    }
    var domNum = countNodes(document.body);
    if (domNum < LEAST_DOM_NUM) {
        immediateSend({
            type: 2,
            log_type: LogType.CRASH
        });
    }
}
// 初始化
export function firstReport(globalReportConfig) {
    try {
        // // 监听动态插入的标签
        if (IS_SUPPORT_PERFORMANCE) {
            observeTagInsert();
        }
        var onloadSend = function () {
            // load 后 3秒做白屏检测
            setTimeout(function () {
                detectWhiteScreen();
            }, 3000);
            var onloadSend = function () {
                var performaceDataObj = {};
                if (IS_SUPPORT_PERFORMANCE) {
                    // 遍历body子元素，往cachedDataBeforeLoad插入数据
                    bodyAssetsPushToCached();
                    // 页面性能上报
                    performaceDataObj = sendPerformanceRequest();
                }
                immediateSend(__assign(__assign({}, globalReportConfig), { type: 2, log_type: LogType.INIT, extra: {
                        performaceDataObj: util.encodeData(performaceDataObj)
                    } }));
            };
            // 为了拿到完整的性能数据
            setTimeout(onloadSend);
        };
        if (!document.readyState ||
            (document.readyState && document.readyState === 'complete')) {
            onloadSend();
        }
        else {
            window.addEventListener('load', onloadSend);
        }
        window.addEventListener('beforeunload', reportAll);
    }
    catch (e) {
        console.error(e);
    }
}
